import { useMediaQuery } from 'react-responsive';

export const useIsDesktop = () => {
  return useMediaQuery({ minWidth: 992 });
};

export const useIsTablet = () => {
  return useMediaQuery({ minWidth: 768, maxWidth: 991 });
};

export const useIsMobile = () => {
  return useMediaQuery({ maxWidth: 767 });
};

export const useIsNotMobile = () => {
  return useMediaQuery({ minWidth: 768 });
};
